import React from "react";
import PropTypes from "prop-types";
import { FaRegQuestionCircle } from "react-icons/fa";
import CommonSwal from "../../Swal/commonSwal";

function Hint({ hint, icon = "info" }) {
  const handleClick = () => {
    CommonSwal({
      title: hint,
      icon: icon,
    });
  };

  return (
    <FaRegQuestionCircle
      onClick={handleClick}
      title={hint}
      style={{
        color: "#556ee6",
        paddingLeft: "4px",
        cursor: "pointer",
        width: "1.15rem",
        height: "1.15rem",
      }}
    />
  );
}

Hint.propTypes = {
  hint: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default Hint;
